module.exports = __webpack_public_path__ + "Server-Disabled.AzureServiceFabricCluster.245de203a5601400fb6f7e86fcbdb9c7.hashedasset.svg";